import { render } from "./Header2.vue?vue&type=template&id=fa35812c"
import script from "./Header2.vue?vue&type=script&lang=js"
export * from "./Header2.vue?vue&type=script&lang=js"

import "./Header2.vue?vue&type=style&index=0&id=fa35812c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__